export const state = () => ({
  value: 0
});

export const mutations = {
  increment(state: any) {
    state.value++;
  }
};
